var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-main',[_c('Buscador',{attrs:{"field_tipos_documentales":'backup_tipos_documentales'}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }